export default __webpack_public_path__ + "static/media/avatar-four.cf31bd3d.svg";